import { Link } from 'react-router-dom';
import { Heart, Coffee } from 'lucide-react';

const KOFI_URL = 'https://ko-fi.com/mirnalinivenkatraman';

export default function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground mt-auto">
      <div className="container mx-auto px-6 md:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <h3 className="font-heading text-2xl font-light mb-4">what2gift</h3>
            <p className="font-body text-sm leading-relaxed opacity-90">
              Thoughtfully curated children's books and gifts that truly matter.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-body text-sm font-semibold uppercase tracking-widest mb-4">Explore</h4>
            <div className="space-y-2">
              <Link
                to="/books"
                className="block font-body text-sm opacity-90 hover:opacity-100 transition-opacity"
                data-testid="footer-books-link"
              >
                Children's Books
              </Link>
              <Link
                to="/gifts/expecting-new-moms"
                className="block font-body text-sm opacity-90 hover:opacity-100 transition-opacity"
                data-testid="footer-moms-link"
              >
                Gifts for New & Expecting Moms
              </Link>
              <Link
                to="/gifts/toddlers"
                className="block font-body text-sm opacity-90 hover:opacity-100 transition-opacity"
                data-testid="footer-toddlers-link"
              >
                For Toddlers
              </Link>
              <Link
                to="/gifts/non-toy-gifts-for-kids"
                className="block font-body text-sm opacity-90 hover:opacity-100 transition-opacity"
                data-testid="footer-kids-link"
              >
                Gifts That Aren't Toys
              </Link>
              <Link
                to="/about"
                className="block font-body text-sm opacity-90 hover:opacity-100 transition-opacity"
                data-testid="footer-about-link"
              >
                About
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-body text-sm font-semibold uppercase tracking-widest mb-4">Connect</h4>
            <p className="font-body text-sm opacity-90 leading-relaxed">
              Have questions or suggestions?
              <br />
              We'd love to hear from you.
            </p>
            <a
              href={KOFI_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-2 bg-primary-foreground text-primary font-body text-sm font-semibold px-4 py-2 rounded-full hover:opacity-90 transition-opacity"
              data-testid="footer-kofi-link"
            >
              <Coffee className="h-4 w-4" /> Support Us on Ko-fi
            </a>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-primary-foreground/20 space-y-3">
          <p className="font-body text-xs text-center opacity-70 max-w-2xl mx-auto leading-relaxed" data-testid="footer-affiliate-disclosure">
            As an Amazon Associate, what2gift earns from qualifying purchases. Some links on this site are affiliate
            links, which means we may earn a small commission at no extra cost to you. This helps us keep curating
            thoughtfully.
          </p>
          <p className="font-body text-sm text-center opacity-75 flex items-center justify-center gap-2">
            Made with <Heart className="h-4 w-4" /> for thoughtful gift-givers
          </p>
        </div>
      </div>
    </footer>
  );
}